import React, {useEffect, useState} from 'react';
import mime from 'mime-types';
import Spinner from '../../../../../_common/components/Spinner';
import {getFilePreview} from '../../../../../OrderDetails/_redux/actions/OrderFilesActions';
import DocxEditorSyncFusion from '../../../../../_common/components/DocxEditor';
import styles from './styles.module.scss';

interface MediaPreviewProps {
  orderID: number;
  fileExtension: string,
  fileName: string,
}

const MediaPreview = ({fileName, orderID, fileExtension}: MediaPreviewProps) => {
  const [loading, setLoading] = useState(true);
  const [file, setFile] = useState<string>('');

  useEffect(() => {
    setLoading(true);
    uploadFile().finally(() => setLoading(false));
  }, []);

  const uploadFile = async () => {
    const mimeType = mime.lookup(fileExtension);
    const file: string = await getFilePreview({orderID, fileName});
    const dataURL = `data:${mimeType};base64,${file}`;
    setFile(dataURL);
  };

  const renderPreview = () => {
    const mimeType = mime.lookup(fileExtension);
    const isImage = (typeof mimeType === 'string') && mimeType.startsWith('image');
    const isOfficeDocument = fileExtension === 'doc' || fileExtension === 'docx';
    if (isOfficeDocument) {
      return (
        <DocxEditorSyncFusion
          file={file}
          readOnly={true}
          restrictEditing={true}
          className={styles.preview}
          height={'80vh'}
        />
      );
    } else if (isImage) {
      return (
        <div className={styles.preview}>
          <img src={file} alt="image preview"/>
        </div>
      );
    } else {
      return <iframe width="100%" height="100%" src={file} className={styles.preview}></iframe>;
    }
  };

  return loading
    ? <Spinner customContainerStyles={styles.spinnerContainer}/>
    : renderPreview();
};

export default MediaPreview;